import React from 'react';
import { sgiCtnBaseFun } from './SgiCtnComm';
import { setFunction } from './sgiBaseComp/SgiCommon';

class SgiLabel extends React.Component {
    static defaultProps = {
    };
    static props = {
    };

    constructor(props) {
        super(props);
        //初始化state
        this.state = {
            labelprops: { style: {} },
            loading: false
        }
    }



    /**
    * @param {父组件} parentModule
    * @param {组件描述} moduleDesc
    * @param {绑定实例ID} bdInst
    * @param {对象工厂} objFct
    * @param {make类型} type
    */
    label_mk(parentModule, moduleDesc, bdInst, objFct, type) {
        // if (!moduleDesc) {
        //     return;
        // }
        this.AddLabelAttribute(moduleDesc, this.state.labelprops);
    }

    AddLabelAttribute(moduleDesc, labelprops) {

        if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
            let text = Resource.getTRByPrm(moduleDesc).te; //设置标签
            if (text) labelprops.value = text;
        }

        let height = moduleDesc.ctlH;
        if (height) labelprops.style.height = height;
        let width = moduleDesc.ctlW;
        if (width) labelprops.style.width = width;

        //显示图片
        // var disply = moduleDesc.disply;
        // if(disply){ 
        //     labelprops.src = disply;    
        // }
        // var show = moduleDesc.alt;
        // if(show){
        //     labelprops.alt = show;
        // }
        // //图片的大小设置
        // 

        // 自定义样式
        let cstmStyle = moduleDesc.cstmStyle;
        let $cstmStyle;
        if (cstmStyle) {
            try {
                $cstmStyle = new Function("module", "objFct", cstmStyle);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            // this.state.cstmStyle = $cstmStyle;
            setFunction(this, "cstmStyle", $cstmStyle);
        }
    }

    setValue(value) {
        if (value === this.state.labelprops.value) return;

        this.state.labelprops.value = value;

        this.setState({});
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            this.label_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn(this.state.labelprops);

        return (
            <div {...this.state.labelprops}>
                {this.state.labelprops.value}
            </div>
        );
    }
}

//给类添加公共方法
Object.assign(SgiLabel.prototype, sgiCtnBaseFun);

export { SgiLabel };
export default SgiLabel;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiLabel.js